import React, { useState } from 'react';
import './FAQ.css';
import dental1 from '../home/Images/v1.png';
import dental2 from '../home/Images/IMG20240913134831.jpg';
import dental3 from '../home/Images/IMG_20231201_174221.jpg';
import dental4 from '../home/Images/dental2.png';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
import { FaCoffee, FaChild, FaClock, FaRegCheckCircle, FaTv, FaCalendarCheck, FaTag, FaCreditCard, FaMedkit } from 'react-icons/fa';

const FAQ = () => {
    const [openQuestion, setOpenQuestion] = useState(null);

    const toggleQuestion = (index) => {
        setOpenQuestion(openQuestion === index ? null : index);
    };

    const faqs = [
        "What is Invisalign?",
        "What is the cost of Invisalign in Worli, Mumbai?",
        "What is the duration of Invisalign treatment in India?",
        "Does Invisalign work for travelling or outstation patients?",
        "What is the best age for getting braces in children?",
        "Are braces painful?",
        "What are the food restrictions with braces?        ",
        "Do teeth go back to same condition after getting braces?",
        "Why do I need a root canal if I don’t have pain?",
        "Why do I need a cap after root canal treatment?",
        "Why do I need to protect the milk teeth of my child if they are going to fall anyway?",
        "Why are dental implants so expensive?"
    ];

    const faqAnswers = [
        "Invisalign is the brand name of the best aligner system in the world, that provides customized, transparent well-fitting clear aligners. Invisalign treatment is much less noticeable than traditional braces or wires; and is extremely predictable as it is based on 25 years of data and 18 million patients worldwide.",
        "The cost of Invisalign in Worli at Bombay dental company depends on the severity of the dental condition and furthermore the category of Invisalign treatment the patient falls in. The cost of Invisalign can range from 1 lac – 3 lacs.",
        "The duration of Invisalign treatment depends on the severity of the dental condition and the category of Invisalign treatment the patient is assigned, that is mild, moderate or severe. The mild category treatment is usually finished in 14 weeks. The moderate category ranges from 6-7 months and the severe category of Invisalign treatment can go up to 12-15 months.",
        " Invisalign works the best for outstation and travelling patients as it is software driven and AI controlled. Most patients at Bombay dental company, Worli, South Mumbai are young adults travelling for work, higher studies, getting married and moving away or visiting from a different city. After getting their Invisalign aligners, patients are put on the Virtual care feature of Invisalign, through which the Invisalign doctor can track their progress virtually through AI, making the treatment outcome successful.",
        "The best age for children to get braces are when all their milk teeth have fallen and been replaced by permanent teeth. This can be anywhere from 11-12.5 years of age. But in some cases, if milk teeth do not fall post this age, they need to be intentionally removed and braces are prescribed to make space for permanent teeth.",
        " Braces treatment at Worli is completely pain-free and pain-managed. The braces are uncomfortable for 1-2 days as the teeth and gums get used to the new addition in the mouth. It is comparable to wearing a new shoe that bites for a day or two, after which we get adjusted to it easily.",
        "The food restrictions with braces are fairly simple. Patients are instructed to take small bites and avoid eating excessively hard and sticky food to avoid breakage of braces and continue the treatment smoothly.        ",
        "Teeth do not go back to the normal condition after removing braces as patients are given retainers which hold the teeth in place till they get fixed in the new position.",
        "When the cavity has extended beyond the superficial surface of the tooth into the nerves and blood vessels, the tooth is completely infected, followed by pain in most cases and no sensation in few cases. This eventually leads to slow breakdown of tooth structure, to restore a tooth for continuing its functions, a root canal treatment followed by crowns is recommended.        ",
        "Root canal treatment involves the cleaning and removal of nerves and blood vessels of the tooth to remove infection. This saves the tooth but leaves it hollow from within. During chewing, the tooth in the opposite arch hits against this hollow tooth continuously which can lead to fracture of the tooth, a dental crown is recommended for to avoid this.",
        "Milk teeth are place holders for guiding permanent teeth into position. If they fall too soon, the future teeth will come only at a fixed time and during this time A) The patient has difficulty in eating without teeth present and B) the remaining teeth migrate into the free space haphazardly leaving no space for future teeth. Hence Pedodontics is a separate field to preserve the precious milk teeth of children."
        ,"Dental implants are made of titanium. They are unbreakable and are the next best thing to a natural tooth. They have lifetime warranty and never undergo any kind of wear and tear, outliving the patient himself, making them a wise investment to replace missing teeth."
    ];

    const barItems = [
        { icon: <FaTv size={50} />, label: "TVs + Headphone" },
        { icon: <FaCalendarCheck size={50} />, label: "Curated Experience" },
        { icon: <FaTag size={50} />, label: "New Patient" },
        { icon: <FaCreditCard size={50} />, label: "Flexible Bill Plans" },
        { icon: <FaCoffee size={50} />, label: "Beverage Bar" },
        { icon: <FaChild size={50} />, label: "Kids Corner" },
        { icon: <FaRegCheckCircle size={50} />, label: "OSHA Approved" },
        { icon: <FaMedkit size={50} />, label: "Emergency" },
        { icon: <FaClock />, label: "Time Management" },
    ];

    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        draggable: false,
        swipe: false,
        centerMode: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div className='faq'>
            <div className="faq-sec1">
                <div className="content">
                    <div className="text-section">
                        <p className="trusted-text"><mark className='domark'>ABOUT BOMBAY DENTAL CLINIC</mark></p>
                        <h1 className='exceptional'><mark className='expmrk'>Learn about our </mark></h1>
                        <h1 className='exceptional'><mark className='expmrk'>practice, and how </mark></h1>
                        <h1 className='exceptional'><mark className='expmrk'> to get started!</mark></h1>
                        <a href="/booknow"><button className="book-button">BOOK ONLINE</button></a>
                        <p className="call-text">OR CALL <a href="tel:+918882672980">088826 72980</a></p>
                    </div>
                </div>
            </div>
            <div className="faq-sec2">
                <div className="faq-section">
                    {faqs.map((faq, index) => (
                        <div className="faq-item" key={index}>
                            <button className="faq-question" onClick={() => toggleQuestion(index)}>
                                {faq} <span>{openQuestion === index ? '-' : '+'}</span>
                            </button>
                            {openQuestion === index && (
                                <div className="faq-answer">
                                    <p>{faqAnswers[index]}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            <div className="dental-bar-menu" style={{ margin: "0 0px", backgroundColor: "white" }}>
                <h2 className="menu-title" style={{ textAlign: "center", color: "black" }}>
                    Bombay Dental Company Menu
                </h2>
                <Slider {...sliderSettings}>
                    {barItems.map((item, index) => (
                        <div key={index} className="menu-item" style={{ textAlign: "center", height: "100%" }}>
                            <div className="icon" style={{ marginBottom: "10px", color: " #0047AB" }}>
                                {item.icon}
                            </div>
                            <p className="label" style={{ color: " #0047AB" }}>
                                {item.label}
                            </p>
                        </div>
                    ))}
                </Slider>
            </div>
            <div className="visit-us-container">
                <div className="images-container">
                    <img src={dental1} alt="Waiting Area" className="image-item" />
                    <img src={dental2} alt="Exam Room" className="image-item" />
                    <img src={dental3} alt="Sign" className="image-item" />
                    <img src={dental4} alt="Lounge" className="image-item" />
                </div>
                <div className="info-container">
                    <h1 className='visit'>Visit Us</h1>
                    <p className='weare'>
                        We are conveniently located right on the Worli Naka, on the first floor of Atur House, opposite the Bharat Petroleum Pump. Our guards are very helpful, and free parking is provided easily upon asking.
                    </p>
                    <div className="lhflex">
                        <div className="location">
                            <h1 className='tp'><IoLocationOutline /></h1>
                            <p> Bombay Dental Company<br />
                                Atur House<br />
                                First Floor, Flat no 2<br />
                                Worli Naka, Worli<br />
                                Mumbai 400018
                            </p>
                            <a href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018" className="directions-link" target="_blank" rel="noopener noreferrer">Get Directions</a>
                        </div>
                        <div className="hours">
                            <h1 className='tp'><IoTimeOutline /></h1>
                            <p> Mon-Sat 9 am – 7 pm<br />
                                Sun 10 am – 2 pm<br />
                                Thursday off
                            </p>
                        </div>
                    </div>
                </div>
                <div className="map-container">
                    <iframe
                        src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
                        width="100%"
                        height="450"
                        style={{ border: "8px", borderRadius: "18px " }}
                        allowFullScreen
                        loading="lazy"
                        title="Google Maps Location of Bombay Dental Company" />
                </div>
            </div>
            <div className="home-sec8">
                <div className="book-visit-container">
                    <div className="online">
                        <h1 className='book'>Book your visit online</h1>
                        <p className='view'>Book your visit online and enjoy our unique No-wait policy, so that you have time for what you enjoy, and not spend your precious time in the doctor’s waiting area.
                            A few lucky callers every month will be randomly shortlisted for a free scaling and polishing session.</p>
                        <a href="/booknow"><button className="book-button1">BOOK ONLINE</button></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
